<ngx-loading [show]="loading" style="z-index: 9999;"></ngx-loading>

<h2 mat-dialog-title *ngIf="!thisObject && entityType !== 'student'">Adaugare job nou</h2>
<h2 mat-dialog-title *ngIf="thisObject && entityType !== 'student'">Modificare job: <b>{{thisObject.name}}</b></h2>
<h2 mat-dialog-title *ngIf="entityType === 'student'">Detalii job: <b>{{thisObject.name}}</b></h2>

<mat-dialog-content style="height: 85%!important;">

  <mat-tab-group mat-align-tabs="start">
    <mat-tab label="Detalii Job">

      <mat-card>
        <mat-card-content *ngIf="!readonly">

          <form [formGroup]="objectForm" style="width: 100%">

            <div fxLayout fxLayoutWrap fxLayoutGap="25px">
              <mat-form-field style="width: 100%">
                <mat-label>Denumire</mat-label>
                <input matInput formControlName="name" style="width: 100%">
                <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                <mat-error *ngIf="objectForm.get('name').errors?.serverError">{{ objectForm.get('name').errors?.serverError }}</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="width: 100%">

              <mat-form-field appearance="standard" fxFlex="33" class="pr-4">
                <mat-label>Tip job</mat-label>
                <mat-select formControlName="jobType" style="width: 100%!important;" [(ngModel)]="selectedJobType" [compareWith]="compareObjects" >
                  <mat-option *ngFor="let jobType of listOfJobTypes" [value]="jobType">{{jobType.name}}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="standard" fxFlex="33" class="pr-4">
                <mat-label>Judet</mat-label>
                <mat-select formControlName="county" style="width: 100%!important;" [(ngModel)]="selectedCounty" [compareWith]="compareObjects" (valueChange)="onCountyChange($event)">
                  <mat-option *ngFor="let county of listOfCounties" [value]="county">{{county.name}}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="standard" fxFlex="33" class="pr-4">
                <mat-label>Oras</mat-label>
                <mat-select formControlName="city" style="width: 100%!important;" [(ngModel)]="selectedCity" [compareWith]="compareObjects" >
                  <mat-option *ngFor="let city of listOfCities" [value]="city">{{city.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="width: 100%">

              <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                <mat-label>Pozitie</mat-label>
                <input matInput formControlName="position" style="width: 100%">
                <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                <mat-error *ngIf="objectForm.get('position').errors?.serverError">{{ objectForm.get('position').errors?.serverError }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                <mat-label>Industrie</mat-label>
                <input matInput formControlName="industry" style="width: 100%">
                <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                <mat-error *ngIf="objectForm.get('industry').errors?.serverError">{{ objectForm.get('industry').errors?.serverError }}</mat-error>
              </mat-form-field>

            </div>

            <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="width: 100%">
              <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                <mat-label>Departamente</mat-label>
                <mat-chip-list #chipListDepartment ngDefaultControl  aria-label="Adauga departamente">
                  <mat-chip *ngFor="let item of selectedDepartmens" [selectable]="true" [removable]="true" (removed)="removeDepartments(item)">
                    {{item.name}}
                    <mat-icon matChipRemove >cancel</mat-icon>
                  </mat-chip>
                  <input placeholder="Adauga departamente"  style="width: 100%"
                         [matChipInputFor]="chipListDepartment"
                         [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                         [matChipInputAddOnBlur]="true"
                         (matChipInputTokenEnd)="addDepartments($event)">
                </mat-chip-list>
                <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                <mat-error *ngIf="objectForm.get('departments').errors?.serverError">{{ objectForm.get('departments').errors?.serverError }}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                <mat-label>Competente necesare</mat-label>
                <mat-chip-list #chipListComp ngDefaultControl  aria-label="Adauga competente necesare">
                  <mat-chip *ngFor="let item of selectedCompetentRequired" [selectable]="true" [removable]="true" (removed)="removeCompetentRequired(item)">
                    {{item.name}}
                    <mat-icon matChipRemove >cancel</mat-icon>
                  </mat-chip>
                  <input placeholder="Adauga o competente"  style="width: 100%"
                         [matChipInputFor]="chipListComp"
                         [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                         [matChipInputAddOnBlur]="true"
                         (matChipInputTokenEnd)="addCompetentRequired($event)">
                </mat-chip-list>
                <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                <mat-error *ngIf="objectForm.get('competentRequired').errors?.serverError">{{ objectForm.get('competentRequired').errors?.serverError }}</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="width: 100%">

              <mat-form-field appearance="standard" fxFlex="50" class="pr-4">
                <mat-label>Valabil pana la</mat-label>
                <input #startDateInput matInput formControlName="validUntil"  [matDatepicker]="picker" placeholder="">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="objectForm.get('validUntil').errors?.serverError">{{ objectForm.get('validUntil').errors?.serverError }}</mat-error>
              </mat-form-field>

              <div class="checkBoxWrapper pr-4" fxFlex="50">
                <mat-checkbox formControlName="mandatoryRecommendation" [checked]="false">Se poate aplica doar prin recomandare</mat-checkbox>
              </div>

            </div>

            <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="width: 100%">

              <mat-form-field appearance="standard" style="width: 100%">
                <mat-label>Descriere</mat-label>
                <textarea matInput formControlName="description" placeholder="Descriere cat mai detaliata a job-ului.... " rows="10" ></textarea>
                <mat-error *ngIf="objectForm.get('description').errors?.serverError">{{ objectForm.get('description').errors?.serverError }}</mat-error>
              </mat-form-field>


            </div>

          </form>

        </mat-card-content>

        <mat-card-content *ngIf="readonly">
          <mat-list>
            <div mat-subheader>Detalii Job: {{thisObject.name}}</div>
            <mat-list-item *ngFor="let item of jobDetails">
              <mat-icon mat-list-icon>arrow_right_alt</mat-icon>
              <div mat-line>{{item.key}}</div>
              <div mat-line>{{item.value}}</div>
            </mat-list-item>
          </mat-list>
          <p *ngIf="(checkUserRecommendation === false && thisObject.mandatoryRecommendation === 1 ) && userService.isStudent()">Pentru a aplica la acest job, ai nevoie de o recomandare din partea universitatii!</p>
        </mat-card-content>

      </mat-card>

    </mat-tab>
    <mat-tab label="Candidati" *ngIf="thisObject && !userService.isStudent()">
      <app-candidates-show *ngFor="let candidate of listOfCandidates" [candidate]="candidate"></app-candidates-show>
      <p *ngIf="listOfCandidates.length === 0"> Nu sunt candidati pentru acest job!</p>
    </mat-tab>
    <mat-tab label="Recomandari" *ngIf="thisObject && !userService.isStudent()">
      <div style="width: 100%" *ngIf="thisObject && userService.isUniversitate()">

        <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="margin: 20px">

          <mat-form-field appearance="standard" fxFlex="85" class="pr-4">
            <mat-label>Recomanda unui student acest job</mat-label>
            <mat-select style="width: 100%!important;" [(ngModel)]="selectedStudentForRecommendation" [compareWith]="compareObjects" (select)="onSelectStudent($event)">
              <mat-option *ngFor="let student of listOfStudents" [value]="student">{{student.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <button fxFlex="15" mat-button color="primary" (click)="makeRecommendations()" [disabled]="!selectedStudentForRecommendation">Recomanda!</button>

        </div>



      </div>

      <app-recommendations *ngFor="let recomandation of listOfRecomandations" [recommendation]="recomandation"></app-recommendations>
      <p *ngIf="listOfRecomandations.length === 0"> Nu sunt recomandari pentru acest job!</p>
    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="actions">

    <div class="delete-button" *ngIf="userService.isAdmin()">
      <button class="mat-raised-button mat-warn" (click)="onDeleteClick()">Delete</button>
    </div>

    <div class="action-buttons">
      <button class="mat-raised-button" mat-dialog-close (click)="onClickCancel()">Inchide</button>

        <button *ngIf="userService.isStudent() && showApplyButton()" class="mat-raised-button mat-primary" (click)="applyAsStudent()" [disabled]="checkUserRecommendation === false && thisObject.mandatoryRecommendation === 1">Aplica pentru acest job!</button>
      <button *ngIf="!userService.isStudent()"  class="mat-raised-button mat-primary" [disabled]="objectForm.invalid"  (click)="onClickSave()" >Salveaza</button>
    </div>

  </div>
</mat-dialog-actions>

